import React from 'react';
import TwitterIcon from '../../../static/images/utils/twitter.svg'
import GoogleIcon from '../../../static/images/utils/google.svg'
import FormInput from "../../Atoms/Templates/FormInput";
import PasswordInput from "../../Atoms/Forms/PasswordInput";
import Checkbox from "../../Atoms/Forms/Checkbox";
import OAuthButton from "../../Atoms/Buttons/OAuthButton";
import WelcomeContainer from "../../Wrappers/WelcomeContainer";
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import ValidatorForm from "../../../helpers/validator";
import {signIn} from "../../../services/user";
import {notifyError} from "../../../services/notification";

const API_URL = process.env.REACT_APP_API_URL

const LoginForm = () => {
  const dispatch = useDispatch()

  const submit = (form) => {
    const credentials = {
      email: form.email.value,
      password: form.password.value,
    };

    const rules = {email: "required|email", password: "required"};
    const validation = new ValidatorForm(credentials, rules);
    if (validation.fails()) {
      dispatch(notifyError(validation.errors()))
      return;
    }
    dispatch(signIn(credentials))
  };

  return (
    <WelcomeContainer
      title="Bienvenido de nuevo"
      submit={submit}
    >
      {/* Botones para iniciar sesión por OAuth*/}
      <div className="ed-grid s-grid-2 gap-2">
        <OAuthButton icon={GoogleIcon}
                     src={`${API_URL}oauth?type=google`}/>
        <OAuthButton icon={TwitterIcon}
                     src={`${API_URL}oauth?type=twitter`}/>
      </div>

      {/* Iniciar sesión con correo electrónico */}
      <FormInput
        id="login-email"
        label="Correo electrónico"
        name="email"
        placeholder="juan@hotmail.com"
        type="email"
      />
      <div>
        <PasswordInput className="s-mb-12px"/>
        <div className="flex smaller">
          <Checkbox label="Recuérdame"/>
          <Link to="/recuperar" className="s-to-right">¿Olvidaste tu contraseña?</Link>
        </div>
      </div>
      <div>
        <input type="submit"
               value="Inicia sesión"
               className="button full s-mb-12px"
        />
        <p className="s-mb-0 small">¿No tienes una cuenta? <Link to="/registro">Regístrate</Link></p>
      </div>
    </WelcomeContainer>
  );
};

export default LoginForm;
